import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { Theme } from "@mui/material/styles";
import { SystemSetting } from "../../../types/system-setting.type";
import SettingRow from "./SettingRow";
import { settingNote } from "./settingMeta";

const COLUMNS = [
  { label: "การตั้งค่า", width: undefined },
  { label: "ค่าปัจจุบัน", width: 280 },
  { label: "แก้ไขล่าสุด", width: 180 },
  { label: "จัดการ", width: 100 },
];

const SKELETON_ROW_COUNT = 3;
const SKELETON_ROWS = Array.from({ length: SKELETON_ROW_COUNT }, (_, index) => index);
const HEAD_SX = { bgcolor: (theme: Theme) => theme.palette.background.default };
const EMPTY_CELL_SX = { py: 5 } as const;

interface SettingsTableProps {
  settings: SystemSetting[];
  /** Every setting, for notes that depend on a setting of another tab. */
  allSettings: SystemSetting[];
  loading: boolean;
  onEdit: (setting: SystemSetting) => void;
  onOpenHistory: (setting: SystemSetting) => void;
}

export default function SettingsTable({
  settings,
  allSettings,
  loading,
  onEdit,
  onOpenHistory,
}: Readonly<SettingsTableProps>) {
  const isEmpty = !loading && settings.length === 0;

  return (
    <Paper>
      <TableContainer>
        <Table>
          <TableHead sx={HEAD_SX}>
            <TableRow>
              {COLUMNS.map((column) => (
                <TableCell key={column.label} sx={{ width: column.width }}>
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading &&
              SKELETON_ROWS.map((row) => (
                <TableRow key={row}>
                  {COLUMNS.map((column) => (
                    <TableCell key={column.label}>
                      <Skeleton variant="text" />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            {isEmpty && (
              <TableRow>
                <TableCell colSpan={COLUMNS.length} align="center" sx={EMPTY_CELL_SX}>
                  <Typography color="text.secondary" fontWeight={500}>
                    ไม่มีการตั้งค่าในหมวดนี้
                  </Typography>
                </TableCell>
              </TableRow>
            )}
            {!loading &&
              settings.map((setting) => (
                <SettingRow
                  key={setting.key}
                  setting={setting}
                  note={settingNote(setting, allSettings)}
                  onEdit={onEdit}
                  onOpenHistory={onOpenHistory}
                />
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
